import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  horizontal: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    position: "relative",
  },
  vertical: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
    position: "relative",
  },
  line: {
    flex: 1,
    borderTop: `1px solid #DCDCDC`,
  },
  verticalLine: {
    flex: 1,
    borderLeft: `1px solid #DCDCDC`,
  },
  content: {
    fontFamily: "Lato, sans-serif",
    fontSize: "0.875rem",
    color: "#0C0E29",
    opacity: 0.8,
    margin: `0 .5rem`,
    whiteSpace: "nowrap",
    padding: "0 0.5rem", // Optional: Add padding around the content
  },
}));

const Divider = ({ orientation = "horizontal", children, className, ...props }) => {
  const classes = useStyles();
  const isHorizontal = orientation === "horizontal";

  return (
    <div className={`${classes.root} ${isHorizontal ? classes.horizontal : classes.vertical} ${className || ""}`} {...props}>
      {isHorizontal ? (
        <>
          <span className={classes.line} />
          {children && <span className={classes.content}>{children}</span>}
          <span className={classes.line} />
        </>
      ) : (
        <>
          <span className={classes.verticalLine} />
          {children && <span className={classes.content}>{children}</span>}
          <span className={classes.verticalLine} />
        </>
      )}
    </div>
  );
};

Divider.propTypes = {
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Divider;
